import React, { useEffect } from "react";

import { WarningIcon } from "../chakraExports";

import {
  alertVariant,
  messageContainer,
  primaryMessageStyle,
  secondaryMessageStyle
} from "./Alert.css";
import { CloseButton } from "./CloseButton";
import { SuccessIcon } from "./SuccessIcon";
import { timeoutValue } from "./helpers";

type AlertProps = {
  type: "error" | "success" | "info";
  primaryMessage: string | React.ReactNode;
  secondaryMessage?: string | React.ReactNode;
  hideIcon?: boolean;
  disableAutoClose?: boolean;
  close?: () => void;
};

export const DeprecatedAlert: React.FC<AlertProps> = ({
  type,
  primaryMessage,
  secondaryMessage,
  hideIcon = false,
  disableAutoClose = false,
  close
}) => {
  useEffect(() => {
    if (!close || disableAutoClose) return;

    const timeout = setTimeout(() => {
      close();
    }, timeoutValue);

    return () => clearTimeout(timeout);
  }, [close, disableAutoClose]);

  const Icon =
    type === "error" ? (
      <WarningIcon />
    ) : (
      <SuccessIcon style={{ marginTop: "6px" }} />
    );

  return (
    <div
      data-type={type}
      className={`${messageContainer} ${alertVariant[type]}`}
    >
      {!hideIcon && <div style={{ alignSelf: "flex-start" }}>{Icon}</div>}
      <div
        style={{
          width: "100%"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <div className={primaryMessageStyle}>{primaryMessage}</div>
          {close && <CloseButton width="28" height="28" onClick={close} />}
        </div>
        {secondaryMessage && (
          <div className={secondaryMessageStyle}>{secondaryMessage}</div>
        )}
      </div>
    </div>
  );
};
